<template>
  <div>

    <div v-if="msTime.show">
      <span>距离
        <span style="font-weight:bold">{{startStr.month}}</span>
        月
        <span style="font-weight:bold">{{startStr.day}}</span>日
        <span style="font-weight:bold">{{startStr.timer}}</span>{{ tipText }}</span>
      <!--<span v-if="!tipShow">{{tipTextEnd}}:</span>-->
      <!-- v-if="msTime.day>0" -->
      <div style="margin:10px 0px 0px;font-size:20px">
        <span>
          <span style="font-size:22px;font-weight:bolder">{{ msTime.day }}</span>
          <span>{{ dayTxt }}</span>
        </span>
        <span style="font-size:22px;font-weight:bolder">{{ msTime.hour }}</span>
        <span>{{ hourTxt }}</span>
        <span style="font-size:22px;font-weight:bolder">{{ msTime.minutes }}</span>
        <span>{{ minutesTxt }}</span>
        <span style="font-size:22px;font-weight:bolder">{{ msTime.seconds }}</span>
        <span>{{ secondsTxt }}</span>
      </div>
    </div>
    <!--<p v-if="!msTime.show">{{endText}}</p>-->
  </div>
</template>
<script>
export default {
  replace: true,
  props: {
    // 距离开始提示文字
    tipText: {
      type: String,
      default: "开始",
    },
    // 距离结束提示文字
    tipTextEnd: {
      type: String,
      default: "结束",
    },
    // 时间控件ID
    id: {
      type: String,
      default: "1",
    },
    // 当前时间
    currentTime: {
      type: Number,
      default: new Date().getTime(),
    },
    // 活动开始时间
    startTime: {
      type: Number,
      default: null,
    },
    // 活动结束时间
    endTime: {
      type: Number,
      default: null,
    },
    // 倒计时结束显示文本
    endText: {
      type: String,
      default: "已结束",
    },
    // 自定义显示文字:天
    dayTxt: {
      type: String,
      default: ":",
    },
    // 自定义显示文字:时
    hourTxt: {
      type: String,
      default: ":",
    },
    // 自定义显示文字:分
    minutesTxt: {
      type: String,
      default: ":",
    },
    secondsTxt: {
      type: String,
      default: ":",
    },
    // 是否开启秒表倒计，未完成
    secondsFixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      msTime: {
        // 倒计时数值
        show: false, // 倒计时状态
        day: "", // 天
        hour: "", // 小时
        minutes: "", // 分钟
        seconds: "", // 秒
      },
      startStr: {
        month: "",
        day: "",
        timer: "",
      },
      star: "", // 活动开始时间
      end: "", // 活动结束时间
      current: "", // 当前时间
    };
  },
  watch: {
    currentTime: function (val, oldval) {
      this.gogogo();
    },
  },
  mounted() {
    this.gogogo();
  },
  methods: {
    gogogo() {
      this.updateStartStr();
      this.normalizeTimes();
      this.schedule();
    },
    // 补零：单数字前补 0
    pad2(n) {
      return n > 9 ? n : "0" + n;
    },
    // 统一为毫秒：10 位时间戳视为秒
    toMs(t) {
      return String(t).length === 10 ? t * 1000 : t;
    },
    // 更新开始时间的展示文案
    updateStartStr() {
      const d = new Date(this.startTime);
      this.startStr.month = this.pad2(d.getMonth() + 1);
      this.startStr.day = this.pad2(d.getDate());
      this.startStr.timer = `${this.pad2(d.getHours())}:${this.pad2(d.getMinutes())}`;
    },
    // 将各时间统一为毫秒
    normalizeTimes() {
      this.star = this.toMs(this.startTime);
      this.end = this.toMs(this.endTime);
      this.current = this.currentTime ? this.toMs(this.currentTime) : Date.now();
    },
    // 根据时间关系调度倒计时
    schedule() {
      // 结束时间小于当前时间：活动已结束
      if (this.end < this.current) {
        this.msTime.show = false;
        this.end_message();
        return;
      }
      // 当前时间小于开始时间：活动尚未开始
      if (this.current < this.star) {
        setTimeout(() => this.runTime(this.star, this.current, this.start_message), 1);
        return;
      }
      // 活动进行中：执行结束倒计时
      this.msTime.show = true;
      this.$emit("start_callback", this.msTime.show);
      setTimeout(() => this.runTime(this.end, this.star, this.end_message, true), 1);
    },
    runTime(startTime, endTime, callFun, type) {
      const msTime = this.msTime;
      let timeDistance = startTime - endTime;
      if (timeDistance > 0) {
        this.msTime.show = true;
        msTime.day = Math.floor(timeDistance / 86400000);
        timeDistance -= msTime.day * 86400000;
        msTime.hour = Math.floor(timeDistance / 3600000);
        timeDistance -= msTime.hour * 3600000;
        msTime.minutes = Math.floor(timeDistance / 60000);
        timeDistance -= msTime.minutes * 60000;

        msTime.seconds = Math.floor(timeDistance / 1000).toFixed(0);
        timeDistance -= msTime.seconds * 1000;
        if (msTime.hour < 10) {
          msTime.hour = "0" + msTime.hour;
        }
        if (msTime.minutes < 10) {
          msTime.minutes = "0" + msTime.minutes;
        }
        if (msTime.seconds < 10) {
          msTime.seconds = "0" + msTime.seconds;
        }
        const _s = Date.now();
        const _e = Date.now();
        const diffPerFunc = _e - _s;
        setTimeout(() => {
          if (type) {
            this.runTime(this.end, (endTime += 1000), callFun, true);
          } else {
            this.runTime(this.star, (endTime += 1000), callFun);
          }
        }, 1000 - diffPerFunc);
      } else {
        callFun();
      }
    },
    start_message() {
      this.$emit("start_callback", this.msTime.show);
      setTimeout(() => {
        this.runTime(this.end, this.star, this.end_message, true);
      }, 1);
    },
    end_message() {
      this.msTime.show = false;
      if (this.currentTime <= 0) {
        return;
      }
      this.$emit("end_callback", this.msTime.show);
    },
  },
};
</script>
